module.exports = __webpack_public_path__ + "static/media/speakerTwo.649160e8.jpg";